// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarServicosOrcamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for buscar_servicos_orcamento endpoint
 *
 * Returns a list of orcamento servicos with enriched data. Reuses
 * Agenda_BuscarOrcamentoServicosOrcamentoServicoRow because both
 * branches (with/without status filter) return the same per-row shape
 * (Orcamentos_model::buscar_servicos_orcamento /
 * Orcamentos_model::buscar_servicos_orcamento_com_status).
 */
import type { Agenda_BuscarOrcamentoServicosOrcamentoServicoRow } from './Agenda_BuscarOrcamentoServicosOrcamentoServicoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_BuscarServicosOrcamentoResponseDados {
servicos: Agenda_BuscarOrcamentoServicosOrcamentoServicoRow[]
}

export type Agenda_BuscarServicosOrcamentoResponse = ApiResponse<Agenda_BuscarServicosOrcamentoResponseDados>;

registerResponseContract('Agenda_BuscarServicosOrcamentoResponse', {
  servicos: {
    type: 'array',
    required: true,
    items: {
      orcamento_servico_id:            { type: 'number',  required: true },
      orcamento_id:                    { type: 'number',  required: false },
      servico_id:                      { type: 'number',  required: false },
      servico_valor:                   { type: 'number',  required: false },
      orcamento_servico_qtd:           { type: 'number',  required: false },
      orcamento_servico_user_id:       { type: 'string',  required: false },
      orcamento_servico_tipo:          { type: 'number',  required: false },
      orcamento_servico_status:        { type: 'number',  required: true },
      orcamento_servico_data_cadastro: { type: 'string',  required: false },
      orcamento_franquia_id:           { type: 'number',  required: true },
      servico_nome:                    { type: 'string',  required: true },
      servicoscategoria_id:            { type: 'number',  required: false },
    },
  },
})
